export const backgrounds = [
  require('~/../assets/backgrounds/spacejoy-9M66C_w_ToM-unsplash.jpg'),
  require('~/../assets/backgrounds/spacejoy-umAXneH4GhA-unsplash.jpg'),
  require('~/../assets/backgrounds/spacejoy-9M66C_w_ToM-unsplash.jpg'),
  require('~/../assets/backgrounds/spacejoy-IH7wPsjwomc-unsplash.jpg'),
  require('~/../assets/backgrounds/spacejoy-YqFz7UMm8qE-unsplash.jpg'),
  require('~/../assets/backgrounds/suhyeon-choi-ehxwis6Ltxg-unsplash.jpg'),
]

export const getRandomBackgroundImage = () => {
  const randomIndex = Math.floor(Math.random() * backgrounds.length)
  return backgrounds[randomIndex]
}
